<template>
  <div>
    <layout menu-item="5">
      <div v-if="loaded" class="inner-container">
        <div v-for="question in questions">
          <question class="question" :questionData="question" @onSave="save" @onDelete="remove"/>
        </div>
        <div style="clear: left"></div>
        <button class="btn btn-primary" @click="addQuestion">Neue Frage</button>
      </div>
    </layout>
  </div>
</template>

<script>

  import Backend from '@/Backend';
  import Question from "./Question";

  export default {
    components: {Question},
    name: "quiz",
    data() {
      return {
        loaded: false,
        questions: []
      }
    },
    methods: {
      addQuestion() {
        Backend.instance.addQuestion()
          .then((data) => {
            this.questions = data;
          });
      },
      save(data) {
        Backend.instance.saveQuestion(data._id, data.question, data.answers);
      },
      remove(question) {
        Backend.instance.removeQuestion(data._id);
      }
    },
    mounted() {
      Backend.instance.getQuestions()
        .then((data) => {
          console.log(data);
          this.questions = data;
          this.loaded = true;
        });
    }

  }
</script>

<style scoped>
  .question {
    float:left;
    margin-left: 1rem;
  }
</style>



// WEBPACK FOOTER //
// src/components/quiz/Quiz.vue